import ApiBase from 'Services/Api/ApiBase';

class Documents extends ApiBase {
    route = '/human-resources/documents';
};

export default new Documents();